export default __webpack_public_path__ + "static/media/inplace.c0644d7d.png";